// extracted by mini-css-extract-plugin
module.exports = {"container":"Comment_container__2LKky","comment":"Comment_comment__2n_LY","active":"Comment_active__L_gt8"};